import React, { Component } from "react";

import TextField from "./form/TextField";
import TextareaField from "./form/TextareaField";
import Checkboxes from "./form/Checkboxes";
import moment from "moment";
import Modal from "./Modal";
import db from "../../api/db";
import CircularProgress from "@material-ui/core/CircularProgress";

class Clientcard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      array: {
        name: "",
        contact_person: "",
        address: "",
        postalcode: "",
        city: "",
        phone: "",
        fax: "",
        comment: "",
        jubilee: [],
        subscriptions: [],
        postalcodes: "",
        mails: "",
        export: "",
        id: ""
      },
      loading: true,
      disabled: false,
      id: this.props.client,
      new: false,
      deletemodal: false,
      deletetest: ""
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleCloseDeleteModal = () => this.setState({ deletemodal: false });
  handleShowDeleteModal = () => this.setState({ deletemodal: true });
  handleDeleteTestChange = e => this.setState({ deletetest: e.target.value });
  handleDelete = () => this.DeleteClient();

  defaultState() {
    return {
      array: {
        name: "",
        contact_person: "",
        address: "",
        postalcode: "",
        city: "",
        phone: "",
        fax: "",
        comment: "",
        jubilee: [],
        subscriptions: [],
        postalcodes: "",
        mails: "",
        export: "",
        id: ""
      },
      id: "",
      loading: false,
      new: true,
      deletemodal: false,
      deletetest: ""
    };
  }

  componentDidMount() {
    if (this.state.id && this.state.id !== "new") {
      this.getSingledoc();
    } else if (this.state.id === "new") {
      const defaultState = this.defaultState();
      this.setState(defaultState);
    }
  }

  componentWillReceiveProps(props) {
    if (props.client === "new") {
      console.log("new");
      const defaultState = this.defaultState();
      this.setState(defaultState);
    } else if (
      props.client !== this.state.array.id ||
      props.client !== this.state.id
    ) {
      this.setState({
        loading: true
      });
      this.getSingledoc(props.client);
    }
  }

  getSingledoc(id = this.state.id) {
    db.get("client", id).then(response => {
      this.setState({
        array: response.data,
        id: response.data.id,
        new: false,
        loading: false
      });
    });
  }

  jubileeOptions() {
    return [
      {
        key: "16",
        name: "16"
      },
      {
        key: "18",
        name: "18"
      },
      {
        key: "20",
        name: "20"
      },
      {
        key: "25",
        name: "25"
      },
      {
        key: "30",
        name: "30"
      },
      {
        key: "35",
        name: "35"
      },
      {
        key: "40",
        name: "40"
      },
      {
        key: "45",
        name: "45"
      },
      {
        key: "50",
        name: "50"
      },
      {
        key: "55",
        name: "55"
      },
      {
        key: "60",
        name: "60"
      },
      {
        key: "65",
        name: "65"
      },
      {
        key: "70",
        name: "70"
      },
      {
        key: "75",
        name: "75"
      },
      {
        key: "80",
        name: "80"
      },
      {
        key: "85",
        name: "85"
      },
      {
        key: "90",
        name: "90"
      },
      {
        key: "95",
        name: "95"
      },
      {
        key: "100",
        name: "100"
      }
    ];
  }

  handleChange(event, arrays) {
    let client = this.state.array;

    if (!arrays) {
      client[event.target.name] = event.target.value;
    }

    this.setState({
      array: client
    });
  }

  DeleteClient() {
    if (this.state.deletetest === "SLETTE") {
      db.delete("client", this.state.id).then(response => {
        this.setState(this.defaultState());
        this.props.clear();
      });
    } else {
      this.setState({
        deletetest: ""
      });
    }
  }

  handleSubmit(event) {
    event.preventDefault();

    if (!this.state.new) {
      this.setState({
        disabled: true
      });

      const client = this.state.array;

      db.patch("client", {
        id: client.id,
        name: client.name,
        contact_person: client.contact_person,
        address: client.address,
        postalcode: client.postalcode,
        city: client.city,
        phone: client.phone,
        fax: client.fax,
        comment: client.comment,
        jubilee: client.jubilee,
        subscriptions: client.subscriptions,
        postalcodes: client.postalcodes ? client.postalcodes : [],
        mails: client.mails ? client.mails : [],
        export: client.export,
        short: client.short,
        update: moment().format()
      })
        .then(response => {
          this.setState({
            array: response.data,
            disabled: false
          });
        })
        .catch(err => {
          console.log(err);
        });
    } else {
      this.setState({
        loading: true
      });

      let client = this.state.array;

      db.create("client", client).then(response => {
        this.setState({
          loading: false,
          array: response.data,
          new: false,
          id: response.data.id
        });
      });
    }
  }

  handleAbort(event) {
    this.props.clear();
    this.setState({
      id: ""
    });
  }

  render() {
    const client = this.state.array;

    if (!this.state.id && !this.state.new) {
      console.log("null");
      return null;
    }

    if (this.state.loading) {
      return (
        <div className="client-card-form-holder">
          <CircularProgress size={20} />
        </div>
      );
    }

    let metadata;

    if (this.state.id !== "new" && client.update) {
      metadata = (
        <div className="cell shrink metadata">
          Oppdatert: {moment(client.update).format("DD.MM YYYY, HH:mm")}
        </div>
      );
    }

    return (
      <div className="client-card-form-holder">
        <form className="client-card-form" onSubmit={this.handleSubmit}>
          <div className="grid-x">
            <div className="cell auto heading">
              {client.name} {client.short ? "(" + client.short + ")" : ""}
            </div>
            {metadata}
          </div>
          <fieldset disabled={this.state.disabled}>
            <div className="grid-x">
              <div className="medium-5 cell col-1">
                <TextField
                  disabled={!this.state.new}
                  className="white-input"
                  name="id"
                  value={client.id}
                  label="ID"
                  onChange={this.handleChange}
                  required={true}
                />
                <div className="grid-x">
                  <div className="medium-8 cell c1">
                    <TextField
                      className="white-input"
                      name="name"
                      value={client.name}
                      label="Abonnent"
                      onChange={this.handleChange}
                      required={true}
                    />
                  </div>
                  <div className="medium-4 cell">
                    <TextField
                      className="white-input"
                      name="short"
                      value={client.short}
                      label="Forkortelse"
                      onChange={this.handleChange}
                      required={true}
                    />
                  </div>
                </div>
                <TextField
                  className="white-input"
                  name="address"
                  value={client.address}
                  label="Adresse"
                  onChange={this.handleChange}
                />
                <div className="grid-x">
                  <div className="small-4 cell c1">
                    <TextField
                      className="white-input"
                      name="postalcode"
                      value={client.postalcode}
                      label="Postnr."
                      onChange={this.handleChange}
                    />
                  </div>
                  <div className="small-8 cell">
                    <TextField
                      className="white-input small-6 cell"
                      name="city"
                      value={client.city}
                      label="Sted"
                      onChange={this.handleChange}
                    />
                  </div>
                </div>
              </div>
              <div className="medium-5 cell col-2">
                <TextField
                  className="white-input"
                  name="contact_person"
                  value={client.contact_person}
                  label="Kontaktperson"
                  onChange={this.handleChange}
                />
                <TextField
                  className="white-input"
                  name="mails"
                  value={client.mails}
                  label="Epost"
                  onChange={this.handleChange}
                />
                <TextField
                  className="white-input"
                  name="phone"
                  value={client.phone}
                  label="Telefon"
                  onChange={this.handleChange}
                />
              </div>
              <div className="medium-2 cell col-3">
                <div className="subheading">Tjenester</div>
                <Checkboxes
                  name="subscriptions"
                  value={client.subscriptions}
                  onChange={this.handleChange}
                  items={[
                    {
                      key: "fleng",
                      name: "Fødselsdager"
                    },
                    {
                      key: "mention",
                      name: "Omtale"
                    },
                    {
                      key: "jubilee",
                      name: "Jubilantliste"
                    }
                  ]}
                />
              </div>
            </div>
            <TextareaField
              className="white-input"
              name="comment"
              value={client.comment}
              label="Kommentar"
              onChange={this.handleChange}
            />
            <Checkboxes
              className="checkboxes"
              label="Abonnerer på"
              name="jubilee"
              value={client.jubilee}
              onChange={this.handleChange}
              items={this.jubileeOptions()}
            />
            <div className="section">
              <div className="subheading">Postnumre</div>
              <TextareaField
                className="white-input"
                name="postalcodes"
                value={client.postalcodes}
                label="Postnummer"
                onChange={this.handleChange}
              />
            </div>
            <div className="footer">
              <input
                className="button"
                type="submit"
                value={this.state.disabled ? "Lagrer..." : "Lagre"}
              />
              <input
                className="button red"
                onClick={e => this.handleShowDeleteModal()}
                type="button"
                value="Slett"
              />
              <input
                className="button link"
                onClick={e => this.handleAbort()}
                type="button"
                value="Avbryt"
              />
            </div>
          </fieldset>
        </form>
        {this.state.deletemodal ? (
          <Modal onClose={this.handleCloseDeleteModal} closelabel="Lukk">
            <div>
              <div className="heading">
                Er du helt sikker på at du vil slette "{client.name}"?
              </div>
              <div className="grid-x">
                <p>For å slette kunden må du skrive inn: SLETTE</p>
                <p>
                  Når du sletter vil ALL data bli ugjenkallelig slettet for all
                  fremtid. Dette kan IKKE gjøres om.
                </p>
              </div>
              <TextField
                className="white-input"
                name="deletetest"
                value={this.state.deletetest}
                label="Bekreftelsestekst"
                onChange={this.handleDeleteTestChange}
              />
            </div>
            <button className="button red" onClick={this.handleDelete}>
              Slett
            </button>
            <button
              className="button link"
              onClick={this.handleCloseDeleteModal}
            >
              Avbryt
            </button>
          </Modal>
        ) : null}
      </div>
    );
  }
}

export default Clientcard;
